var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 90,
    viewBox: "0 0 91 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4031 7.95607C15.3267 -0.813771 28.0927 -2.21008 36.7483 4.85574L45.5 12L54.2517 4.85575C62.9073 -2.21007 75.6733 -0.813762 82.5969 7.95608L84.2518 10.0523C93.3393 21.5631 92.7726 37.9568 82.9119 48.8126L45.5 90L8.08809 48.8126C-1.77259 37.9568 -2.33929 21.5631 6.74819 10.0523L8.4031 7.95607Z",
    fill: "#DD0D75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.fcafaaa18d179214b0bf9975ff09d803.svg";
export { ForwardRef as ReactComponent };